import { render, staticRenderFns } from "./DashboardProfessionalBreakdown.vue?vue&type=template&id=5e06a886&scoped=true"
import script from "./DashboardProfessionalBreakdown.vue?vue&type=script&lang=js"
export * from "./DashboardProfessionalBreakdown.vue?vue&type=script&lang=js"
import style0 from "./DashboardProfessionalBreakdown.vue?vue&type=style&index=0&id=5e06a886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06a886",
  null
  
)

export default component.exports